// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1_8ab","modalFooterButton":"ModalNotes_modalFooterButton___DIke"};